// store.
import { RootState } from '@store';

export const getListPolygons = (state: RootState) =>
  state.domainModePolygon.listPolygons;

export const getIntersectionListHandler = (state: RootState) =>
  state.domainModePolygon.intersectionListHandler;
